import { CookieKeys, getCookie } from '../sharedModules/getCookie';

import getUrlParameters from './getUrlParameters';

export const getTrackingArea = (): string | undefined => {
  const { trackingArea } = getUrlParameters();
  return trackingArea ?? getCookie(CookieKeys.FTR_COUNTRY_CODE);
};
